const logoAndIcon = {
  state: {
    merchantLogo: '',
    merchantIcon: ''
  },
  mutations: {
    SET_LOGOANDICON (state, [key, value]) {
      state[key] = value
    }
  }
}

export default logoAndIcon



// WEBPACK FOOTER //
// ./src/store/modules/logoAndIcon.js